<template>
  <section class="page-container">
    <div
      class="filter-bar"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
            @click="showFilterCard = false"></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
            @click="showFilterCard = true"></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Effective Start Date</span>
            <v-date-picker
              v-model="effective_date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>
              Insurer
              <span
                v-if="company_id.length"
                class="all"
                @click="handlerNoneAll('company_id')">None</span>
            </span>
            <span>
              <v-select
                v-model="company_id"
                placeholder="All"
                multiple
                :list="insurerList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Partner
              <span
                v-if="partner_filter_id.length"
                class="all"
                @click="handlerNoneAll('partner_filter_id')">None</span>
            </span>
            <span>
              <v-select
                v-model="partner_filter_id"
                placeholder="All"
                multiple
                :list="partnerList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Referrer
            </span>
            <span>
              <v-input
                v-model="referrer_code"
                @change="filterData" />
            </span>
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>
            </span>
            <v-checkbox-group
              v-model="stts"
              :list="policyStatusOption"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange-light': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>            </span>
            <v-checkbox-group
              v-model="effe"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Tag
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>
            </span>
            <v-checkbox-group
              v-model="tags"
              :list="policyTagsOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gold': item.id == 1,
                      'blue': [2,16,64,256].includes(item.id),
                      'orange': item.id == 4,
                      'black': [8,32,128].includes(item.id),
                      'red': [512].includes(item.id),
                      'gray': [1024, 2048].includes(item.id)
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>

          <div class="form-item">
            <span>
              Channel
              <span
                class="all"
                @click="handlerSelectAll('source')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('source')">None</span>
            </span>
            <span>
              <v-checkbox-group
                v-model="source"
                :list="specialOptions.source"
                :isColumn="false"
                @change="filterData"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <policy-table-list
      :table-data="tableData"
      is-mgm></policy-table-list>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinMarketing from '@/mixins/marketing'
import policyTableList from '@/views/marketing/components/policyTableList'

export default {
  name: 'policyMgmReportList',
  components:{
    policyTableList
  },
  mixins: [MixinMarketing],
  props:{
    isFulfilled:{
      type:Boolean,
      default:false
    },
    isList:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      date: [],
      effective_date: [],
      company_id: [],
      referrer_code: '',
      stts: [],//1, 2, 3, 4
      effe: [],
      tags: [],
      typ_of_bdy_id: [],
      statusList: [],
      showFilterCard: true,
      source: [],
      is_mgm:1,
      defaultFilter:{
        date: [],
        company_id: [],
        effe: [],
        tags: [],
        stts: [],
        source: [],
        partner_filter_id: [],
        effective_date: [],
        typ_of_bdy_id: [],
        referrer_code:'',
        is_mgm:1,
      },
      partner_filter_id: [],

    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/marketing/marketing';
.filter-left{
  width: 335px!important;
  flex: inherit!important;
}
.filter-middler{
  width: 355px!important;
  flex: inherit!important;
}
.filter-right{
  border-right: 0px!important;
}
</style>
